import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { useOptionalHouseholdChatContext } from '../contexts/householdChat.context';
import { getOpenChatConversationPath } from '../householdChatDeepLink';

/**
 * Returns a callback that opens the household agent on a specific conversation.
 *
 * When the target household is the one already in view its chat provider is
 * mounted, so the conversation is selected directly and the user stays on the
 * page they're on. Otherwise we navigate to that household with a deep-link
 * param the provider consumes once it mounts.
 */
export function useOpenHouseholdChatConversation() {
  const navigate = useNavigate();
  const chat = useOptionalHouseholdChatContext();

  return useCallback(
    (householdId: string, conversationId: string) => {
      if (chat?.householdId === householdId) {
        chat.selectConversation(conversationId);
        chat.openChat();
        return;
      }

      navigate(getOpenChatConversationPath(householdId, conversationId));
    },
    [chat, navigate]
  );
}
